import { QUOTE_TYPE_ID } from 'customer-data-objects/constants/ObjectTypeIds';
import { normalizeTypeId } from 'customer-data-objects/constants/ObjectTypeIds';

// TODO: In an effort to scale better™ we'd eventually like to move this capability to the schema metadata service once it's available
// through GraphQL. Context: https://hubspot.slack.com/archives/C017SPT9U5P/p1611243088010600
const readOnlyObjectTypeIdSet = new Set([QUOTE_TYPE_ID]);
export default (objectTypeId => {
  return readOnlyObjectTypeIdSet.has(normalizeTypeId(objectTypeId));
});